const CID = Number(process.env.VUE_APP_CID);

export default {
	namespaced: true,
	state: {
		CID,
		mainMenu: {
			isVertical: (CID === 1 || CID === 4 || CID === 5),
			isFlex: (CID === 8),
			hasLogo: (CID !== 5),
			logoCentered: (CID === 2),
			logoCenteredFlex: (CID === 8),
			expandableItems: (CID === 3 || CID === 4 || CID === 7 || CID === 8 || CID === 12 || CID === 13),
			hasLanguageBar: (CID === 6 || CID === 7),
			hasTextInMenu: (CID === 6 || CID === 7 || CID === 13 || CID === 14),
			openOnExpand: (CID !== 7 && CID !== 8 && CID !== 12 && CID !== 13),
			closeOnGlobalClick: (CID === 7),
			menuItemDecoration: (CID === 7 || CID === 13),
			menuItemBottomDecoration: (CID === 13),
			menuDecoration: (CID === 7 || CID === 13),
			expandOnHover: (CID === 12 || CID === 13),
			svgLogo: (CID === 14),
			svgParts: {
				14: 3,
			},
			hasLogoText: (CID === 7),
		},
		backgrounds: {
			solidColor: (CID === 5 || CID === 6 || CID === 12),
			noImagesOnPages: (CID === 8),
		},
		header: {
			hasHeader: (CID === 5),
			isFixed: false,
			hasText: (CID === 5),
			headerPage: (CID === 13), // CID === 13
		},
		footer: {
			hasFooter: (CID === 2 || CID === 3 || CID === 6 || CID === 7 || CID === 8 || CID === 9 || CID === 10 || CID === 11 || CID === 12 || CID === 13 || CID === 14),
			footerInSidebar: (CID === 1 || CID === 4 || CID === 6 || CID === 7 || CID === 9 || CID === 10 || CID === 11 || CID === 14),
			hasLanguageBar: (CID !== 5 && CID !== 6 && CID !== 7 && CID !== 9 && CID !== 10 && CID !== 11 && CID !== 12 && CID !== 13 && CID !== 14),
			hasLanguageBarInMenuFooter: (CID !== 8 && CID !== 5 && CID !== 14),
			hasMenu: (CID !== 5),
			hasMenuInMenu: (CID !== 6 && CID !== 7 && CID !== 9 && CID !== 10 && CID !== 11 && CID !== 13 && CID !== 14),
			hasPageInFooter: (CID === 5 || CID === 14),
			hasCopyright: (CID !== 6 && CID !== 7 && CID !== 14),
			hasSocialInFooterInMenu: (CID === 8),
			hasSocialIcons: (CID === 8 || CID === 9 || CID === 10 || CID === 11),
			separateCopyright: (CID === 8),
			footerDecoration: (CID === 7 || CID === 13 || CID === 14),
			footerPage: (CID === 13 || CID === 14),
			seal: {
				white: (CID === 3),
				black: (CID === 2 || CID === 4 || CID === 6 || CID === 7 || CID === 12 || CID === 14),
				footerInSidebar: (CID === 4),
			},
		},
		thumbnail: {
			imageSeparate: {
				list: (CID === 6 || CID === 7 || CID === 12 || CID === 13),
				grid: (CID === 5 || CID === 6 || CID === 7 || CID === 9 || CID === 12), // TODO fix imageseparate on cid 6 and 7
			},
			hideTextContent: (CID === 6 || CID === 7),
		},
		contentParser: {
			imagesAsCSS: (CID === 3 || CID === 4),
			imageAsHeader: (CID === 5 || CID === 6 || CID === 7 || CID === 11 || CID === 12),
		},
		languageBar: {
			standaloneBar: (CID === 9),
		},
		socialIcons: {
			inMenu: (CID === 3 || CID === 6 || CID === 7 || CID === 12),
			inMenuFooter: (CID === 14),
			icons: (CID !== 10 && CID !== 11),
			standaloneBar: (CID === 9 || CID === 10 || CID === 11),
			altIcons: (CID === 7),
		},
		globalAudioPlayer: {
			enabled: (CID === 3 || CID === 8 || CID === 9 || CID === 10 || CID === 11),
			closedOnHomePage: (CID === 9),
		},
		content: {
			contentTopPage: (CID === 13),
		},
		pagesView: {
			titleDecoration: (CID === 9),
		},
		postsView: {
			titleDecoration: (CID === 9 || CID === 14),
			image: (CID === 11),
			scrollToClosestDatePost: (CID === 9),
			separateByYears: (CID === 2 || CID === 9 || CID === 13), // if separateByYears is set, separateCategoryType has to be set
			separateCategoryType: {
				list: (CID === 2),
				note: (CID === 9 || CID === 13),
			},
			hideTitle: {
				all: false,
				children: (CID === 12),
			},
			parentCategoryTitle: (CID === 14),
			tab: {
				noTitleIfOne: (CID === 14),
			},
			// TODO CID === 2 separateByYears - list!
		},
		gallery: {
			separateFullGalleryView: (CID === 6 || CID === 12 || CID === 14),
		},
		scrollToTop: {
			scrollWholePage: (CID === 7 || CID === 13 || CID === 14),
			arrow: (CID === 7 || CID === 13 || CID === 14),
		},
		globallink: (CID === 9),
		loadingSpinner: {
			logoImg: (CID !== 13 && CID !== 14),
			logoSVG: (CID === 13 || CID === 14),
		},
	},
	mutations: {},
	actions: {},
	getters: {
		getFeatureSet(state) {
			return state;
		},
	},
};
